import React from 'react';

import { motion } from 'framer-motion';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';

import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
// import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';

import Icon from '../../../../utils/icon';

import headerimage from '../../../../images/education-banner.png';

function fileExists(imgUrl) {
  const http = new XMLHttpRequest();

  http.open('HEAD', imgUrl, false);
  http.send();

  return http.status !== 404;
}

const HeaderImageDefault =
  '/static-assets/content/images/page-header-elements/header-image-default.png';
const HeaderImageOne =
  '/static-assets/content/images/page-header-elements/content-types/tech-data/header-image-1.png';
// const HeaderImageTwo =
//   '/static-assets/content/images/page-header-elements/content-types/tech-data/header-image-2.png';
// const HeaderImageThree =
//   '/static-assets/content/images/page-header-elements/content-types/tech-data/header-image-3.png';
// const HeaderImageFour =
//   '/static-assets/content/images/page-header-elements/content-types/tech-data/header-image-4.png';
// const HeaderImageFive =
//   '/static-assets/content/images/page-header-elements/content-types/tech-data/header-image-5.png';
const headerImages = [
  HeaderImageOne,
  // HeaderImageTwo,
  // HeaderImageThree,
  // HeaderImageFour,
  // HeaderImageFive,
];

headerImages.forEach((imageObj, index) => {
  if (fileExists(imageObj) === false) {
    headerImages.splice(index);
  }
});

const randomImage =
  headerImages[Math.floor(Math.random() * headerImages.length)];

const useStyles = makeStyles((theme) => ({
  pageheader: {
    backgroundImage: "url('" + headerimage + "')",
    height: 275,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    marginBottom: theme.spacing(8),
  },
  pageheaderelement: {
    opacity: 0,
    height: '100%',
    right: '-400px',
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  pageheaderelementimage: {
    height: '135%',
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  quicklinks: {
    borderBottom: '1px solid ' + theme.palette.secondary.light,
  },
  quickinfo: {
    fontStyle: 'italic',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  quickinfomobile: {
    fontStyle: 'italic',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  cardcontenttype: {
    backgroundColor: theme.palette.primary.highlight,
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1,
  },
}));

const listCategories = (categoriesitem) => {
  return categoriesitem.map((item, index) => {
    return (
      <Box
        key={index}
        width={42}
        height={42}
        borderRadius={100}
        className={item.taxItemName_s}
        display='flex'
        alignItems='center'
        justifyContent='center'
        ml={1}
      >
        <Icon
          name={item.taxItemName_s}
          color='#ffffff'
          widthsize={30}
          heightsize={30}
        />
      </Box>
    );
  });
};

export default function TechDataPageHeader(props) {
  const { ice } = props;
  const classes = useStyles();
  function printPage(e) {
    e.preventDefault();
    window.print();
    return false;
  }
  return (
    <Box pb={4} className={classes.pageheader + ' print-reset-height'}>
      <motion.div
        className={classes.pageheaderelement}
        animate={{ opacity: [0, 0, 0, 0.25, 0.5, 0.75, 1], right: 0 }}
        transition={{ ease: 'easeInOut', duration: '0.6' }}
      >
        <Box height={1} position='relative' bottom={0} right={0}>
          <img
            src={randomImage ? randomImage : HeaderImageDefault}
            alt='metagenics immunity protocol'
            className={classes.pageheaderelementimage}
          />
        </Box>
      </motion.div>
      <Box width={1} position='absolute' bottom='-30px'>
        <Container maxWidth='lg'>
          <Box bottom={32} className='page-header-width'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              className={classes.quickinfomobile + ' no-print'}
              pr={3}
            ></Box>
            <Typography {...ice} variant='h2' gutterBottom>
              {props.title}
            </Typography>
            <Box mb={2}>
              <Typography variant='body1' gutterBottom>
                {props.subtitle}
              </Typography>
            </Box>
          </Box>
        </Container>
        <Container maxWidth='lg' className='no-print'>
          <Box
            width={1}
            bgcolor='#ffffff'
            mt={2}
            py={1}
            px={2}
            borderRadius={32}
            className='item-boxshadow'
            display='flex'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box>
              <Typography
                variant='overline'
                className={classes.cardcontenttype}
                gutterBottom
              >
                Technical Data
              </Typography>
            </Box>
            <Box display='flex' alignItems='center'>
              <Box
                pr={3}
                display='flex'
                alignItems='center'
                justifyContent='center'
                className={classes.quickinfo}
              >
                <Tooltip title='Print' aria-label='print'>
                  <IconButton aria-label='print' onClick={printPage}>
                    <PrintOutlinedIcon color='secondary' />
                  </IconButton>
                </Tooltip>
                {props.pdf && (
                  <Tooltip title='Download PDF' aria-label='download'>
                    <IconButton href={props.pdf} aria-label='save' download>
                      <SaveAltOutlinedIcon color='secondary' />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              {props.categories && listCategories(props.categories)}
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
